import React from 'react';
import { useFormContext } from 'react-hook-form';
import { connect, useDispatch } from 'react-redux';

import { ContinueWithBackButtons } from 'components/base/BottomStepComponent';
import {
  defaultPreviewImage,
  earningRulesCampaignPreview,
} from 'components/campaign/campaignCreation/CampaignStepTwoPreviewConfig';
import { CampaignType, EarningRuleType } from 'config/CustomEnums';

import { validate } from './CreateEarningRuleValidate';
import { CREATION_STEP_TWO_CONFIG } from './EarningRuleCreationConfig';
import { createAction } from 'utils';

import 'components/campaign/campaignCreation/CreateCampaignStepTwo.scss';
import BaseCreationStepContentByConfig from 'components/base/BaseCreationStepContentByConfig';


const mapPropsToState = (state) => ({
  languages: state.language.allList,
});

function CreateEarningRuleStepTwoV2({ languages }) {
  const dispatch = useDispatch();
  const {
    getValues,
    watch,
    clearErrors,
    setError,
  } = useFormContext();

  const linkedStampCampaign = watch('linkedStampCampaign');
  const type = watch('type');
  const inputWithImageConfig = earningRulesCampaignPreview;
  const defaultImage = defaultPreviewImage(CampaignType.earningRulesCampaign);
  const {
    extraValidate,
  } = CREATION_STEP_TWO_CONFIG


  const onlyShowOverview =
    linkedStampCampaign ||
    [
      EarningRuleType.newMember,
      EarningRuleType.birthday,
      EarningRuleType.generalPurchase,
      EarningRuleType.fillingForm,
      EarningRuleType.levelUpgrade,
    ].includes(type)


  const stepChangeAction = (isBack) => {
    let isValid = validate({
      getValues: getValues,
      setError,
      clearErrors,
      step: 1,
      isBack,
    });
    if (extraValidate) {
      isValid = extraValidate({
        getValues,
        setError,
        clearErrors
      }) && isValid
    }
    dispatch(createAction('createEarningRules/stepChange')({
      isBack: isBack,
      step: 1,
      isValid
    }))
  };


  return (
    <>
      <BaseCreationStepContentByConfig
        configuration={CREATION_STEP_TWO_CONFIG}
        inputWithImageConfig={onlyShowOverview ? null : inputWithImageConfig}
        defaultImage={onlyShowOverview ? null : defaultImage}
      />
      <ContinueWithBackButtons
        continueAction={() => {
          stepChangeAction(false);
        }}
        backAction={() => {
          stepChangeAction(true);
        }}
      />
    </>
  );
}


export default connect(mapPropsToState)(CreateEarningRuleStepTwoV2);
